<div class="overlay" *ngIf="showAudioModal || showVideoModal">
  <div class="popupForRefreshPopup bg-white !w-[60%] !p-7 flex">
    <div class="w-1/2 flex items-center justify-center">
      <img
        [src]="commonService.imageBase64String?.disabldAudioOrVideoBase64String"
        alt="Permission Status"
        class="max-w-80"
      />
    </div>

    <div class="w-1/2 flex flex-col justify-center">
      <h1 class="text-2xl text-primary_Text_Color my-3 poppinsMedium">
        {{
          showAudioModal ? "Microphone Access Revoked" : "Camera Access Revoked"
        }}
      </h1>

      <p
        class="text-secondary_Light_Text_Color mb-4 mt-4 font-normal leading-7"
      >
        {{
          showAudioModal
            ? "Your microphone permission has been revoked. Audio access is required to record your responses during the interview. Please re-enable microphone access to continue."
            : "Camera access is required to continue the interview. Please enable camera permissions in your browser or device settings. If access is not granted within 30 seconds, the interview will end automatically."
        }}
      </p>

      <p
        *ngIf="showVideoModal"
        class="text-secondary_Light_Text_Color poppinsMedium"
      >
        Time Remaining
      </p>
      <div *ngIf="showVideoModal" class="my-1 flex justify-center gap-2">
        <div>
          <span class="timeCounter ml-1">
            {{ videoCountdown < 10 ? "0" + videoCountdown : videoCountdown }}
          </span>
          <p class="mt-1 text-secondary_Light_Text_Color text-xs text-center">
            SEC
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
